import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Layout from "../inc/layout-frontend";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import PaysService from "../../services/PaysService";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { removeFromCart, resetCart } from "../../app/providers/panierSlice";
import { app_url } from "../../services/http";
import Table from 'react-bootstrap/Table';
import CommandesService from "../../services/CommandesService";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../../app/providers/authSlice";
import Pagination from 'react-bootstrap/Pagination';





export default function Commander() {

  const [user, setUser] = useState({});

  const [pays, setPays] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const auth = useSelector(state => state.auth)

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [publications, setPublications] = useState([]);

  const itemsPerPage = 5; // Nombre d'éléments par page

  const data = publications;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const publication = data.slice(indexOfFirstItem, indexOfLastItem);

  const [isSaving, setIsSaving] = useState(false);

  const [showMessage, setShowMessage] = useState(false);


  dispatch(checkAuthenticate())

  if (!auth.isAuthenticate) {
    navigate(myroutes.login)
  }



  const { contentPanier } = useSelector(state => state.panier)
  // utilisation de dispatch pour l'exploitation des fonctions depuis le reducer

  // Calcul du nombre total de pages
  //const pageCount = Math.ceil(contentPanier.length / itemsPerPage);

  // Obtenir les éléments à afficher dans la page actuelle

  const startIndex = (currentPage - 1) * itemsPerPage;

  const endIndex = startIndex + itemsPerPage;

  const paginatedData = contentPanier.slice(startIndex, endIndex);


  // récupérer la liste des pays

  useEffect(() => {
    //console.log(contentPanier)
    PaysService.index()
      .then(response => {
        if (Array.isArray(response.data.pays)) {
          setPays(response.data.pays);
        } else {
          console.error('La réponse ne contient pas un tableau de pays:', response.data);
        }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des pays:', error);
      });

  }, []);

  // rechercher le libellé du pays correspondant grâce à l'id de pays 

  const paysLibelle = pays.find((pays) => pays.id === auth.user?.pays_id);

  //************************* générer la référence de la commande */

  // Génère un nombre aléatoire entre 0 et 9999 pour le numéro de commande
  /*
  const generateReference = () => {
      const timestamp = Date.now();
      const uniqueId = Math.floor(Math.random() * 10000); 
      return `CMD-${timestamp}-${uniqueId}`;
    };  
    */
  //console.log(contentPanier)
  const handleSaveCommande = async (event) => {
    event.preventDefault();

    const createdById = auth.user ? auth.user.id : null;
    const updatedById = auth.user ? auth.user.id : null;

    // const reference = generateReference(); // Générer la référence de commande

    const commande = {
      montant_total: contentPanier.reduce((acc, item) => acc + item.price * item.quantity, 0),
      statut_id: 1, // Remplacez la valeur par l'ID du statut de paiement souhaité
      created_by: createdById,
      updated_by: updatedById,
      contenuPanier: contentPanier,
    };

    try {
      // Désactiver le bouton et afficher le message d'attente
      setIsSaving(true);
      setShowMessage("Veuillez patienter pendant l'enregistrement...");

      // Enregistrer la commande principale
      const response = await CommandesService.store(commande, auth.token);
      //console.log(response);

      if (!response.data.erreur) {
        Swal.fire({
          icon: 'success',
          title: 'Enregistrement réussi',
          text: response.data.message,
        });

        // récupérer l'id de la commande 

      navigate(myroutes.paiement, {state:{commande_id:response.data.id, reference_commande:response.data.reference_commande, statut_id:response.data.statut_id}});


      } else {
        Swal.fire({
          icon: "error",
          text: response.data.erreur,
          showConfirmButton: true,
        })
      }
      // Réinitialiser le panier après la validation de la commande
      // dispatch(resetCart());

      // Reste du code...
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Vous avez mal renseigné les champs ou cet élément existe déjà dans la base de données',
      });
      console.error(error);
    } finally {
      // Réactiver le bouton après l'enregistrement (succès ou échec)
      setIsSaving(false);
      setShowMessage("");
    }
  };



  return (
    <Layout>
      {/** Navbar Start */}
      <div className="container-fluid position-relative p-0">
        <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: "90px" }}>
          <div className="row py-5">
            <div className="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-4 text-white animated zoomIn">Commander</h1>
              <Link className="h5" style={{ color: "goldenrod" }} to={myroutes.homepage}>
                Accueil
              </Link>
              <i className="far fa-circle text-white px-2"></i>
              <Link className="h5 text-white" >
                Commander ici
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/** Navbar End */}

      <Container>
        <Row>
          <Col sm={6} >
            <h3 className="mb-4">Informations personnelles</h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>
            <Form onSubmit={handleSaveCommande}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Identifiant  <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.fullname} readOnly minLength="3" maxLength="100" autoFocus />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Adresse  <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.adresse} minLength="3" maxLength="100" autoFocus readOnly />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Téléphone <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.telephone} minLength="3" maxLength="100" autoFocus readOnly />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Email  <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.email} minLength="3" maxLength="100" autoFocus readOnly />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Pays  <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande" type="text" value={paysLibelle ? paysLibelle.nom_pays : '' || ''} minLength="3" maxLength="50" autoFocus readOnly />
              </Form.Group>

              <Button
                className="me-3 mt-4 mb-5"
                type="submit"
                variant="primary"
                style={{ padding: "15px", borderRadius: "4px" }}
                disabled={isSaving} // Désactive le bouton lorsque isSaving est true
              >
                {isSaving ? showMessage : "Confirmer la commande"}
              </Button>{' '}
            </Form>
          </Col>

          <Col sm={1} style={{ minHeight: "100px", backgroundColor: "white" }}>

          </Col>
          <Col sm={5} style={{}}>
            <h3 className="mb-4">  Détails de la commande</h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>

            <Table striped bordered hover size="sm" >
              <thead style={{ backgroundColor: "#116BB9", color: "white", fontSize: "18px" }}>
                <tr>
                  <th style={{ padding: "10px", width: "600px" }}>Parution</th>
                  <th style={{ padding: "10px", width: "200px" }}>Prix</th>
                  <th style={{ padding: "10px", width: "200px" }}>Quantité</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item) => (
                  <tr key={item.id}>

                    <td style={{ padding: "10px", alignItems: "center" }}>
                      <img
                        src={app_url + "/storage/laune/" + item.laune}
                        alt="Image"
                        style={{ width: '50px', height: '70px' }}
                      />
                      <p style={{ marginLeft: "10px", fontSize: "14px", lineHeight: "1.5rem" }}>{item.name}</p>
                    </td>


                    <td style={{ verticalAlign: "middle" }}>{item.price}</td>

                    <td style={{ verticalAlign: "middle" }}>
                      <span style={{ margin: "20px" }}>{item.quantity}</span>
                      <Button onClick={() => dispatch(removeFromCart(item))} variant="danger">
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot style={{ backgroundColor: "rgb(199, 222, 255)" }}>
                <tr>
                  <th colSpan={4} style={{ padding: "10px", textAlign: "center", fontSize: "22px" }}>
                    <span > Total de la commande : {(contentPanier.reduce((acc, item) => acc += item.price * item.quantity, 0)).toLocaleString()} FCFA</span>
                  </th>
                </tr>
              </tfoot>
            </Table>
            
          </Col>
        </Row>
      </Container>
      

    </Layout>

  )
}